import {Action, Store} from "redux";
import {connect} from "react-redux";
import {State} from "./reducers";
import {ValueProps, CallbackProps, OrdersFilters} from "./presentation";
import {
	DateType,
	GeoState,
	GeoStates, OrderStatus, Origin, Origins, PaidStatus, PaymentGroup, PaymentGroups, PaymentMethod,
	PaymentMethods
} from "./data";
import {OrdersFiltersAction} from "./actions";
import {compose, Dispatcher} from "../../lib/utils";

export type OrdersFiltersStore = Store<State>

export type OwnProps = {
	store: OrdersFiltersStore
	paymentMethods: PaymentMethods
	origins: Origins
	states: GeoStates
	paymentGroups: PaymentGroups
}

const mapStateToProps = (s: State, props: OwnProps): ValueProps => ({
	selectedOrderStatus: s.selectedOrderStatus,
	selectedPaidStatus: s.selectedPaidStatus,
	selectedPaymentMethod: s.selectedPaymentMethod,
	selectedOrigin: s.selectedOrigin,
	selectedState: s.selectedState,
	selectedPaymentGroup: s.selectedPaymentGroup,
	selectedDateType: s.selectedDateType,
	fromDate: s.fromDate,
	toDate: s.toDate,

	paymentMethods: props.paymentMethods,
	origins: props.origins,
	states: props.states,
	paymentGroups: props.paymentGroups
})

const mapDispatchToProps = (dispatch: Dispatcher<Action, State>): CallbackProps => {
	const wrap = (action: OrdersFiltersAction) => ({
		type: 'orders filters action',
		action: action
	})
	const dispatchAction = compose(wrap, dispatch)

	return {
		setOrderStatus: (orderStatus: OrderStatus) => dispatchAction({type: 'set order status', orderStatus}),
		setPaidStatus: (paidStatus: PaidStatus) => dispatchAction({type: 'set paid status', paidStatus}),
		setPaymentMethod: (paymentMethod: PaymentMethod) => dispatchAction({type: 'set payment method', paymentMethod}),
		setOrigin: (origin: Origin) => dispatchAction({type: 'set origin', origin}),
		setState: (state: GeoState) => dispatchAction({type: 'set state', state}),
		setPaymentGroup: (paymentGroup: PaymentGroup) => dispatchAction({type: 'set payment group', paymentGroup}),
		setDateType: (dateType: DateType) => dispatchAction({type: 'set date type', dateType}),
		setFromDate: (fromDate: Date) => dispatchAction({type: 'set from date', fromDate}),
		setToDate: (toDate: Date) => dispatchAction({type: 'set to date', toDate}),
		clearFromDate: () => dispatchAction({type: 'clear from date'}),
		clearToDate: () => dispatchAction({type: 'clear to date'}),
	}
}

export const OrdersFiltersApp = connect<ValueProps, CallbackProps, OwnProps, State>(
	mapStateToProps,
	mapDispatchToProps
)(OrdersFilters)



// WEBPACK FOOTER //
// ./src/orders2/orders-filters/app.ts